module.exports = __webpack_public_path__ + "static/media/1.16.a767cc36.png";